export class HardwareBridgeOutcomeUnknownError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "HardwareBridgeOutcomeUnknownError"
  }
}

export class HardwareBridgeFeatureUnsupportedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "HardwareBridgeFeatureUnsupportedError"
  }
}

export class HardwareBridgeReconcileRequiredError extends HardwareBridgeOutcomeUnknownError {
  constructor(message: string) {
    super(message)
    this.name = "HardwareBridgeReconcileRequiredError"
  }
}
